// Homepage-only JSON-LD @graph (WebSite + business node).
export const HOME_GRAPH = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": "https://www.phoenixplumbing.co/#website",
      "url": "https://www.phoenixplumbing.co/",
      "name": "Phoenix Plumbing Co.",
      "alternateName": [
        "Phoenix Plumbing CO",
        "Phoenix Plumbing Company"
      ],
      "publisher": {
        "@id": "https://www.phoenixplumbing.co/#business"
      },
      "inLanguage": "en-US"
    },
    {
      "@type": [
        "Plumber",
        "LocalBusiness",
        "Organization"
      ],
      "@id": "https://www.phoenixplumbing.co/#business",
      "name": "Phoenix Plumbing Co.",
      "alternateName": [
        "Phoenix Plumbing CO",
        "Phoenix Plumbing Company"
      ],
      "legalName": "Phoenix Plumbing Co.",
      "url": "https://www.phoenixplumbing.co/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.phoenixplumbing.co/logo.png"
      },
      "image": "https://www.phoenixplumbing.co/logo.png",
      "telephone": "+1-602-834-1208",
      "email": "phoenixazplumbing@gmail.com",
      "priceRange": "$$",
      "foundingDate": "2012",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "11801 N Tatum Blvd Suite 88",
        "addressLocality": "Phoenix",
        "addressRegion": "AZ",
        "postalCode": "85028",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 33.593771,
        "longitude": -111.9784311
      },
      "hasMap": "https://www.google.com/maps?cid=16475846041163493395",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "06:00",
          "closes": "17:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "06:00",
          "closes": "14:00"
        }
      ],
      "areaServed": [
        {
          "@type": "City",
          "name": "Phoenix"
        },
        {
          "@type": "City",
          "name": "Glendale"
        },
        {
          "@type": "City",
          "name": "Scottsdale"
        },
        {
          "@type": "City",
          "name": "Tempe"
        },
        {
          "@type": "City",
          "name": "Mesa"
        },
        {
          "@type": "City",
          "name": "Chandler"
        },
        {
          "@type": "City",
          "name": "Gilbert"
        },
        {
          "@type": "City",
          "name": "Peoria"
        },
        {
          "@type": "City",
          "name": "Surprise"
        },
        {
          "@type": "City",
          "name": "Goodyear"
        },
        {
          "@type": "City",
          "name": "Avondale"
        },
        {
          "@type": "City",
          "name": "Paradise Valley"
        },
        {
          "@type": "City",
          "name": "Cave Creek"
        },
        {
          "@type": "City",
          "name": "Fountain Hills"
        },
        {
          "@type": "City",
          "name": "Sun City"
        },
        {
          "@type": "City",
          "name": "Anthem"
        }
      ],
      "sameAs": [
        "https://www.google.com/maps?cid=16475846041163493395",
        "https://facebook.com/PhoenixPlumbingCo",
        "https://instagram.com/phoenixplumbingco",
        "https://youtube.com/@PhoenixPlumbingCo",
        "https://twitter.com/PhxPlumbingCo",
        "https://www.yelp.com/biz/phoenix-plumbing-phoenix-7",
        "https://www.chamberofcommerce.com/business-directory/arizona/phoenix/plumber/2034523343-phoenix-plumbing-co",
        "https://ezlocal.com/az/phoenix/plumber/0919070873"
      ]
    }
  ]
} as const;
